'use client';

import React, { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useSession } from 'next-auth/react';
import Image from 'next/image';

const AuthLayout = ({ children }: { children: React.ReactNode }) => {
  const router = useRouter();
  const { status } = useSession();

  const isLoggedIn = status === 'authenticated';

  useEffect(() => {
    if (isLoggedIn) {
      router.push('/');
    }
  }, [isLoggedIn, router]);

  return (
    <div className="relative min-h-screen flex justify-center ">
      <div className="absolute top-2 left-5 p-3 sm:p-5 rounded">
        <Image
          src="/images/logo.svg"
          alt="Logo"
          height={30}
          width={148}
          priority
          suppressHydrationWarning
          className="object-contain"
        />
      </div>
      <div className="w-[100%] xs:w-[70%] md:w-[100%]">{children}</div>
    </div>
  );
};

export default AuthLayout;
